import "./FounderDetails.css";
// import { FaLinkedin, FaTwitter } from "react-icons/fa";
// import { Link } from "react-router-dom";
import founderOne from "../components/asset/founder1.jpg";
import founderTwo from "../components/asset/founder2.jpg";
import founderThree from "../components/asset/founder3.jpg";
import founderFour from "../components/asset/founder4.jpg";
import founderFive from "../components/asset/founder5.jpg";
import founderSix from "../components/asset/founder6.jpg";
import founderSeven from "../components/asset/founder7.jpg";

const FounderDetails = () => {
  return (
    <div className="founders">
      <div className="grid_container_one">
        <div className="founder">
          <img src={founderOne} alt="jephthah" />
          <div className="details bg_1">
            <h4>Jephtah Abu</h4>
            <p>Founder</p>
            {/* <div className="detail-links">
            <Link
              className="founder-icon-link"
              to="https://www.linkedin.com/in/jephtahabu/"
              target="_blank"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </Link>
            <Link
              className="founder-icon-link"
              to="https://twitter.com/jephtahA_"
              target="_blank"
              aria-label="Twitter"
            >
              <FaTwitter />
            </Link>
          </div> */}
          </div>
        </div>

        <div className="founder">
          <img src={founderTwo} alt="lloyd" />
          <div className="details bg_2">
            <h4>Otukpa Lloyd</h4>
            <p>Co-founder/CMO</p>
            {/* <div className="detail-links">
            <Link
              className="founder-icon-link"
              to="https://www.linkedin.com/in/godwinoi/"
              target="_blank"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </Link>
            <Link
              className="founder-icon-link"
              to="https://twitter.com/glucosezaddy90"
              target="_blank"
              aria-label="Twitter"
            >
              <FaTwitter />
            </Link>
          </div> */}
          </div>
        </div>

        {/* changed the rest of the team members 12-11-2025 */}
        <div className="founder">
          <img src={founderThree} alt="ayobami" />
          <div className="details bg_3">
            <h4>Ayobami Dorcas</h4>
            <p>Finance</p>
            {/* <div className="detail-links">
            <Link
              className="founder-icon-link"
              to="https://www.linkedin.com/in/margareth-egbuchulam"
              target="_blank"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </Link>
            <Link
              className="founder-icon-link"
              to="https://x.com/maegy_george?s=21"
              target="_blank"
              aria-label="Twitter"
            >
              <FaTwitter />
            </Link>
          </div> */}
          </div>
        </div>

        <div className="founder">
          <img src={founderFour} alt="sophia" />
          <div className="details bg_2">
            <h4>Olamide Blessing</h4>
            <p>Talent Manager</p>
            {/* <div className="detail-links">
            <Link
              className="founder-icon-link"
              to="https://www.linkedin.com/in/chinemerem-udoye"
              target="_blank"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </Link>
            <Link
              className="founder-icon-link"
              to="https://twitter.com/nemeremkamsiyo?s=21&t=Yl_UCXle_ernRHc4DUkJMg"
              target="_blank"
              aria-label="Twitter"
            >
              <FaTwitter />
            </Link>
          </div> */}
          </div>
        </div>
      </div>

      <div className="grid_container_two">
        <div className="founder">
          <img src={founderFive} alt="precious" />
          <div className="details bg_2">
            <h4>Precious Chioma Iwekauba</h4>
            <p>Recruitment & People Operations</p>
          </div>
        </div>

        <div className="founder">
          <img src={founderSix} alt="olufemi rachel" />
          <div className="details bg_1">
            <h4>Olaide Adekunle</h4>
            <p>Executive Assistant</p>
          </div>
        </div>

        <div className="founder">
          <img src={founderSeven} alt="Aduramigba Oni" />
          <div className="details bg_3">
            <h4>Aduramigba Oni</h4>
            <p>Appointment Setter Intern</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FounderDetails;
